/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../../types/QueryTags'
import { 
  AdvertisementResponse
} from './types'

import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/notification/v1'


const advertisementEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) => 
  ({
    getAdvertisementItems: builder.query<AdvertisementResponse, void>({
      query: () => `${basePath}/broadcasts?onlyActive=true`
    }),
  })

export default advertisementEndpoints